import * as fns from 'date-fns';
import sportsApi from '../sportsApi';
import getFilters from '../../selectors/getSelectedFilters';

const getReport = async (
    filters,
    query,
    client,
): Promise<{
    values: any[];
    total: any;
    changesId: string;
    lastQuery: any;
}> => {
    if (!filters || !query) return;
    const globFilters = getFilters(filters);

    // Startdate is required. Set to EPOCH if not set.
    const fullQuery = { ...query, ...globFilters };
    if (!fullQuery.startDate) {
        fullQuery.startDate = fns.format(
            new Date(0),
            "yyyy-MM-dd'T'HH:mm:ss.SSSXXX",
        );
    }
    if (!fullQuery.client) {
        fullQuery.client = {
            id: client.id,
        };
    }

    const endpoint = `/media-value-reports`;

    return await sportsApi.url(endpoint).json(fullQuery).post().json();
};

export default getReport;
